import React from "react";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function OrderDetails() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 via-green-100 to-green-700 flex flex-col">
      {/* FINCA Brand & Order ID Section */}
      <div className="px-6 pb-8 pt-4">
        <h2 className="text-3xl font-bold text-black mb-2">FINCA</h2>
        <h3 className="text-5xl font-bold text-black tracking-tight">
          #21FNDFLFE
        </h3>
      </div>

      {/* Main Content Card */}
      <main className="px-6 pb-6 ">
        <div className="bg-white rounded-2xl shadow-lg max-w-2xl mx-auto overflow-hidden">
          {/* Back Button */}
          <div className="p-8 pb-6">
            <button
              className="flex items-center gap-2 text-gray-800 font-medium hover:gap-3 transition-all"
              onClick={() => navigate("/dashboard")}
            >
              <ArrowLeft size={20} />
              <span className="text-lg">Back</span>
            </button>
          </div>

          {/* Order Details */}
          <div className="px-8 pb-32">
            <h4 className="text-xl font-bold text-black mb-1">#21FNDFLFE</h4>
            <p className="text-gray-500 text-sm mb-6">06/12/2025</p>

            <ul className="list-disc list-inside">
              <li className="text-gray-800 text-base">2kg Avocado</li>
            </ul>
          </div>

          {/* Message Client Button */}
          <div className="px-8 pb-8 flex justify-center">
            <button className="bg-black text-white px-8 py-3 rounded-lg flex items-center gap-2 hover:bg-gray-800 transition-colors font-medium">
              Message client
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="text-center mt-auto pb-8 text-white text-sm">
        Copyright © 2025 AADA. All rights reserved.
      </footer>
    </div>
  );
}
